export enum ApiVersion {
  v2 = "v2",
  v3 = "v3",
}

export enum Method {
  POST = "POST",
  GET = "GET",
}

export enum Endpoints {
  rooms = "livekit-rooms",
  agent = "agents",
  creator = "creators",
}

export enum SecondPathParams {
  verifyToken = "verify-token",
  manifest = "manifest",
}
